import { render, staticRenderFns } from "./UnavailablePage.vue?vue&type=template&id=0fe816e3&scoped=true&"
import script from "./UnavailablePage.vue?vue&type=script&lang=js&"
export * from "./UnavailablePage.vue?vue&type=script&lang=js&"
import style0 from "./UnavailablePage.vue?vue&type=style&index=0&id=0fe816e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe816e3",
  null
  
)

export default component.exports